import { render, staticRenderFns } from "./ClearWishlistButton.vue?vue&type=template&id=6db4e95e&scoped=true&"
var script = {}
import style0 from "./ClearWishlistButton.vue?vue&type=style&index=0&id=6db4e95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db4e95e",
  null
  
)

export default component.exports